// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"21":"d10b60e9","123":"b148387a","221":"39a5940c","298":"d7eb64da","585":"2edd668f","830":"c14faec1","972":"03b97dc0"}[chunkId] + ".css";
};